import React from 'react';
import { Route } from 'react-router-dom';

const CustomRoute = (props) => {
    return (
        <Route
            label={props.label}
            exact={props.exact}
            path={props.path}
            render={(routeProps) => (<props.component
                label={props.label}
                setLoading={props.setLoading}
                toggleAlert={props.toggleAlert}
                setAlert={props.setAlert}
                {...routeProps}
            />)}
        />
    );
};

export default CustomRoute;
